import styled from 'styled-components'
import ok from '../../../assets/login/ok.svg'
import notok from '../../../assets/login/notok.svg'

export const Container = styled.div`
  position: absolute;
  top: 10%;
  left: 32.5%;
  width: 514px;
  height: 557px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.32);
  overflow: auto;
  font-family: 'Roboto Slab', sans-serif;
  display: grid;

  

  * {
    padding: 10;
    margin: 0;
  }

  .p-inputtext {
    display: block;
    position: relative;
    padding: 10px;

    left: 0%;
    width: 100%;
    height: 40px;

    text-align: left;
    background-color: #f1f1f2;

    border: 0;
    border-radius: 5px;
    font-size: 15px;
  }

  .p-password {
    left: 0%;
  }

  .p-inputwrapper {
    left: 20%;
    width: 60%;
  }

  .inactive {
    color: #777;
  }

  .ok {
    background-image: url(${ok});
  }

  .notok {
    background-image: url(${notok});
  }
`

export const ErrorContainer = styled.div`
  position: absolute;
  top: 40%;
  left: 32.5%;
  width: 35%;
  height: 20%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.32);
  overflow: auto;
  font-family: 'Roboto Slab', sans-serif;

  
  * {
    padding: 10;
    margin: 0;
  }
`

export const LogoDustre = styled.img`
position: relative;
left: 50%;
transform: translate(-50%, 0);
margin: 21px 0 12px 0;


/* RESPONSIVIDADE */

/* laptop */
@media (min-width: 1200px) {
  width: 140px;
}

/* laptop menor */
@media (max-width: 1200px) {
  width: 120px;
}

/* tablets na horizontal */
@media (max-width: 992px) {
  width: 100px;
}

/* tablets na vertical/celulares grandes */
@media (max-width: 768px) {
  width: 90px;
}

/* celulares pequenos */
@media (max-width: 600px) {
  width: 80px;
}
`

export const MainText = styled.h1`
  position: relative;
  left: 20%;
  width: 60%;
  padding: 12px 0 8px 0;
  text-align: center;
  
  

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 16px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 14px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 14px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 11px;
  }
`

export const LoginForm = styled.div`
  padding: 0;
  width: 100%;
  
`


export const Label = styled.label`
  position: relative;
  left: 20%;
  width: 60%;
  height: 40px;
  display: block;
  padding: 15px 0 10px 0;
  text-align: center;
  

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const TextInput = styled.input`
  position: relative;
  left: 20%;
  width: 60%;
  text-align: left;
  height: 40px;
  background-color: #f1f1f2;
  border: 0;
  border-radius: 5px;
  padding: 0 0 0 5px;
  

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const InputButton = styled.input`
  position: relative;
  left: 20%;
  width: 60%;
  margin: 25px 0 25px 0;
  height: 40px;
  text-align: center;
  background-color: #6ec1e4;
  color: white;
  border: 0;
  border-radius: 5px;

  :hover {
    border: 1px black solid;
    cursor: pointer;
  }

  :active {
    background-color: #1f9dd4;
  }

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const Condition = styled.p`
  display: flex;
  position: relative;
  left: 20%;
  width: 80%;
  padding: 6px ;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 11px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 10px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 9px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 8px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 7px;
  }
`

export const ConditionIcon = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(0, 12%);
  margin-right: 5px;
  min-width: 12px;
  min-height: 12px;
  max-width: 12px;
  max-height: 12px;

  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  


  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 11px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 10px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 9px;
  }

  /* tablets na  vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 8px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 7px;
  }
`
